import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "#F8D477",
        stroke: "#DFA30C",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.25",
        d: "m6.5 1.583 1.674 3.391 3.743.547L9.209 8.16l.639 3.727-3.348-1.76-3.347 1.76.639-3.727-2.708-2.638 3.742-.547z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 .5h13v13H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }